import notificationSound from '../assets/sounds/bell_noti.mp3';
  export const playNotificationSoundConversation = () => {
    const audio = new Audio(notificationSound);
    audio.play();
  };

  export const playNotificationAgentConversation = () => {
    const audio = new Audio(notificationSound);
    audio.play();
  };